<template>
  <div
    class="c-contactform"
    :class="[
      { 'c-contactform--slidein': slidein },
      { 'c-contactform--sitemenu': sitemenu },
    ]"
  >
    <div class="c-contactform__intro" v-if="slidein">
      <p class="c-contactform__intro__heading">Bliv ringet op</p>
      <p class="c-contactform__intro__text">
        Udfyld formularen, så ringer vi dig op til en uforpligtende snak
      </p>
    </div>
    <div class="c-contactform__formwrapper">
      <div class="c-contactform__left">
        <div class="c-contactform__input">
          <input
            type="text"
            :id="'fromName-' + locationId"
            class="w-full validate input"
            :class="{ valid: fromName }"
            required="required"
            v-model="fromName"
          />
          <label class="floating-label" :for="'fromName-' + locationId"
            >Navn</label
          >
        </div>
        <div class="c-contactform__input">
          <input
            type="text"
            :id="'contactCompany-' + locationId"
            class="w-full validate input"
            :class="{ valid: company }"
            name="message['company']"
            required="required"
            v-model="company"
          />
          <label class="floating-label" :for="'contactCompany-' + locationId"
            >Virksomhed</label
          >
        </div>
        <div class="c-contactform__input">
          <input
            type="text"
            :id="'email-' + locationId"
            class="w-full validate input"
            :class="{ valid: email }"
            name="email"
            required="required"
            v-model="email"
          />
          <label class="floating-label" :for="'email-' + locationId"
            >E-mail</label
          >
        </div>
        <div class="c-contactform__input">
          <input
            type="text"
            :id="'contactphone-' + locationId"
            class="w-full validate input"
            :class="{ valid: phone }"
            name="phone"
            required="required"
            v-model="phone"
          />
          <label class="floating-label" :for="'contactphone-' + locationId"
            >Telefonnummer</label
          >
        </div>
      </div>
      <div class="c-contactform__right">
        <div class="c-contactform__input c-contactform__input__textarea">
          <textarea
            rows="10"
            cols="40"
            :id="'message-' + locationId"
            :class="{ valid: message }"
            name="message[comment]"
            v-model="message"
          >
          </textarea>
          <label class="floating-label" :for="'message-' + locationId"
            >Hvad vil du kontaktes omkring?</label
          >
        </div>
      </div>
    </div>
    <div class="c-contactform__submit">
      <div class="status" v-if="isError">
        <div class="status__text">
          <p class="status__text__heading">Fejl!</p>
          <p>{{ ErrorMsg }}</p>
        </div>
        <div class="o-btn o-btn--main o-btn--back" @click.prevent="showForm()">
          <iArrow />
          <p>Prøv igen</p>
        </div>
      </div>

      <div class="status" v-if="isSuccess">
        <div class="status__text">
          <p class="status__text__heading">Success!</p>
          <p>Tak for din besked, vi kontakter dig hurtigst muligt</p>
        </div>
        <div class="o-btn o-btn--main" @click.prevent="showForm()">
          <iArrow />
          <p>Okay</p>
        </div>
      </div>
      <!-- <div class="c-contactform__submit__spacer"></div> -->
      <div class="c-contactform__submit__consent" v-if="sitemenu && isForm">
        <input
          class="o-checkbox__input"
          id="sitemenu_cbx"
          type="checkbox"
          style="display: none"
          v-model="isConsent"
        />
        <label class="o-checkbox" for="sitemenu_cbx">
          <span>
            <svg width="12px" height="9px" viewbox="0 0 12 9">
              <polyline points="1 5 4 8 11 1"></polyline>
            </svg>
          </span>
          <span><slot name="consent"></slot></span>
          <!-- <span>Jeg giver hermed samtykke til, at Baden-Jensen A/S må indsamle og gemme mine indtastede data fra denne formular. <a href="https://www.baden-jensen.dk/privatlivspolitik">Læs vores privatlivspolitik.</a></span> -->
        </label>
      </div>
      <div class="c-contactform__submit__consent" v-else-if="slidein && isForm">
        <input
          class="o-checkbox__input"
          id="slidein_cbx"
          type="checkbox"
          style="display: none"
          v-model="isConsent"
        />
        <label class="o-checkbox" for="slidein_cbx">
          <span>
            <svg width="12px" height="9px" viewbox="0 0 12 9">
              <polyline points="1 5 4 8 11 1"></polyline>
            </svg>
          </span>
          <span><slot name="consent"></slot></span>
        </label>
      </div>
      <div class="c-contactform__submit__consent" v-else-if="isForm">
        <input
          class="o-checkbox__input"
          id="cbx"
          type="checkbox"
          style="display: none"
          v-model="isConsent"
        />
        <label class="o-checkbox" for="cbx">
          <span>
            <svg width="12px" height="9px" viewbox="0 0 12 9">
              <polyline points="1 5 4 8 11 1"></polyline>
            </svg>
          </span>
          <span><slot name="consent"></slot></span>
        </label>
      </div>
      <div class="c-contactform__submit__button" v-if="isForm">
        <div
          class="o-btn o-btn--main"
          :class="{
            'o-btn--disabled': !isConsent,
            'o-btn--submitting': isSubmitting,
          }"
          @click="submitForm()"
        >
          <iArrow v-if="!isSubmitting" />
          <div class="bouncyBoisMini" v-if="isSubmitting">
            <div></div>
            <div></div>
            <div></div>
          </div>
          <p>Ring mig op</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import axios from 'axios';

// Store
import { mapState } from 'pinia';
import { useSiteStore } from '../stores/siteStore';

import iArrow from '@web/assets/icon/btnArrow.svg';

export default defineComponent({
  name: 'c-contactform',
  components: {
    iArrow,
  },
  data: () => ({
    fromName: null,
    company: null,
    phone: null,
    message: null,
    email: null,

    isForm: true,
    isConsent: false,
    isSubmitting: false,
    isSuccess: false,
    isError: false,
    ErrorMsg: 'En eller flere felter ikke udfyldt korrekt',
  }),
  props: {
    slidein: Boolean,
    sitemenu: Boolean,
    locationId: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapState(useSiteStore, ['csrf']),
  },
  methods: {
    showForm() {
      this.isForm = true;
      this.isError = false;
      this.isSuccess = false;
      this.isSubmitting = false;
    },
    async submitForm() {
      if (
        !this.fromName ||
        !this.company ||
        !this.phone ||
        !this.message ||
        !this.email
      ) {
        this.isError = true;
        this.statusMsg = 'En eller flere felter ikke udfyldt korrekt';
        this.isForm = false;
      } else {
        const formData = new FormData();
        formData.append('title', this.fromName);
        formData.append('formCompany', this.company);
        formData.append('formEmail', this.email);
        formData.append('formPhone', this.phone ? this.phone : '');
        formData.append('formDescription', this.message ? this.message : '');
        formData.append('form', 'contact');
        this.sendForm(formData);
      }
    },

    sendForm(formData) {
      formData.append('action', 'quantity-frontend/form/submit-form');
      formData.append('CRAFT_CSRF_TOKEN', this.csrf);

      this.isSubmitting = true;
      this.isForm = true;

      axios
        .post(document.location.href, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((res) => {
          if (res.data.success) {
            this.isSubmitting = false;
            this.isError = false;
            this.isSuccess = true;
            this.isForm = false;
          }
          if (res.data.status) {
            this.isError = true;
            this.isSuccess = false;
            this.isSubmitting = false;
            this.isForm = false;
          }
        })
        .catch((e) => {
          this.isError = true;
          console.log(e);
        })
        .then(() => {
          setTimeout(() => {
            this.isSubmitting = false;
            this.isConsent = false;

            this.fromName = null;
            this.company = null;
            this.phone = null;
            this.email = null;
            this.message = null;
          }, 1800);
        });
    },
  },
});
</script>

<style lang="scss">
@import '@backend/scss/abstracts/variables.scss';
@import '@backend/scss/abstracts/mixins.scss';

.c-contactform {
  .status {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;

    &__text {
      flex-grow: 1;
      margin-left: 200px;
      font-size: 12px;
      color: #223452;
      letter-spacing: -0.12px;
      line-height: 17px;
      font-weight: $f-medium;
      padding-right: 30px;

      &__heading {
        font-weight: $f-bold;
      }
    }
  }

  &--slidein {
    padding: 60px;
    .status {
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;

      &__text {
        margin-top: 20px;
        margin-left: 0 !important;
        margin-bottom: 20px;
      }
    }
    .c-contactform {
      &__formwrapper {
        flex-direction: column;
      }

      &__input {
        &__textarea {
          height: 240px;
        }

        input,
        textarea {
          &:focus ~ label,
          &.valid ~ label {
            top: 9px;
          }
        }
      }
      &__left {
        width: 100%;
        padding-right: 0;
      }
      &__right {
        width: 100%;
        padding-left: 0;
      }

      &__submit {
        border: none;
        background-color: transparent;
        flex-direction: column;
        align-items: flex-start;
        padding: 0;
        margin-top: 5px;

        &__consent {
          margin-left: 0;
          .o-checkbox {
            span:last-child {
              opacity: 0.5;
            }
          }
        }

        &__button {
          justify-content: flex-start;
        }
      }
    }
  }

  &--sitemenu {
    padding: 45px;
  }

  &__intro {
    &__heading {
      font-size: 13px;
      letter-spacing: -0.13px;
      font-weight: $f-bold;
      line-height: 16px;
      margin-bottom: 15px;
    }
    &__text {
      font-size: 14px;
      opacity: 0.5;
      letter-spacing: -0.14px;
      line-height: 20px;
      font-weight: $f-medium;
      margin-bottom: 20px;
    }
  }

  &__formwrapper {
    display: flex;
  }
  &__input {
    position: relative;
    height: 60px;
    width: 100%;
    margin-bottom: 5px;

    input,
    textarea {
      width: 100%;
      box-sizing: border-box;
      height: 100%;
      padding: 20px 11px 0px;
      border-radius: 4px;
      border: none;
      border: 1px solid rgba(34, 52, 82, 0.5);
      font-size: 16px;

      &:focus ~ label,
      &.valid ~ label {
        top: 16px;
        left: 12px;
        font-size: 12px;
      }
    }
    textarea {
      padding-top: 35px;
      height: calc(100% - 5px);
    }
    label {
      position: absolute;
      pointer-events: none;
      font-size: 14px;
      line-height: 14px;
      transition: all 0.3s $t-nice;
      color: $c-dark;
      opacity: 0.5;

      top: calc(50% - 7px);
      left: 15px;
    }
    &__textarea {
      height: 100%;
      max-height: 500px;
    }
  }
  &__left {
    width: 50%;
    padding-right: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  &__right {
    width: 50%;
    padding-left: 10px;
    label {
      top: 20px;
    }

    textarea {
      box-sizing: border-box;
      width: 100%;
      resize: none;
    }
  }

  &__submit {
    background-color: rgba(255, 255, 255, 0.4);
    display: flex;
    align-items: center;
    margin-top: 23px;
    border: 1px solid rgba(34, 52, 82, 0.25);
    border-radius: 4px;
    padding: 20px;

    &__consent {
      margin-left: 200px;
      display: flex;
      flex-grow: 1;
    }

    &__button {
      width: 200px;
      min-width: 200px;
      display: flex;
      justify-content: flex-end;
      height: 44px;
    }
  }
}

@media all and (max-width: 1100px) {
  .c-contactform {
    &__submit {
      &__consent {
        margin-left: 10%;
      }
    }

    .status {
      &__text {
        margin-left: 10%;
      }
    }
  }
}

@media all and (max-width: $r-tablet) {
  .c-contactform {
    &__submit {
      &__consent {
        margin-left: 0;
      }
    }
    .status {
      &__text {
        margin-left: 0;
      }
    }
  }
}

@media all and (max-width: 700px) {
  .c-contactform {
    &__submit {
      flex-direction: column;
      align-items: flex-start;

      &__button {
        justify-content: flex-start;
      }
      &__consent {
        margin-left: 0;
      }
    }

    .status {
      flex-direction: column;
      align-items: flex-start;
      &__text {
        flex-grow: 1;
        margin-bottom: 20px;
      }
    }
  }
}

@media all and (max-width: 680px) {
  .c-contactform {
    &__formwrapper {
      flex-direction: column;
    }

    &__input {
      height: 50px;
      margin-bottom: 5px;

      &__textarea {
        height: 150px;
      }

      input,
      textarea {
        &:focus ~ label,
        &.valid ~ label {
          top: 9px;
        }
      }
    }
    &__left {
      width: 100%;
      padding-right: 0;
    }
    &__right {
      width: 100%;
      padding-left: 0;
    }
  }
}
</style>
